/*
 * Copyright © 2017-Present, The Freshwater Trust, all rights reserved.
 */

import React, {Fragment} from "react";

import {SurveyFormInput} from "../../../Components/Common/SurveyForm/SurveyFormInput";

export function SurveyAnswerFieldViewer(props) {

	const {
		question = null,
		answer = null,
		// When true this answer was cleared/removed by the save: `answer` holds the
		// prior value, shown flagged so the activity feed surfaces the removal rather
		// than rendering "No changes." (see SurveyAnswersFieldViewer).
		removed = false,
	} = props;

	if(!question || !answer) {
		return <div>Details unavailable.</div>
	}

	return <Fragment>
		<div className="sb-survey-question">
			{question.name}
		</div>
		<div className={`sb-survey-answer${removed ? " sb-survey-answer-cleared" : ""}`}>
			<SurveyFormInput
				Question={question}
				Answer={answer}
				EditMode={false}
			/>
			{removed
				? <span className="sb-survey-answer-cleared-label">cleared</span>
				: null}
		</div>
	</Fragment>
}
